export const userMapper = new Map<string, Array<string>>()
  .set("King Bhella of Arodene 👑", ["Saneet Bhella"])
  .set("Prince Andrew", ["STANSFIELD AM T"])
  .set('George "ITFC 💩" Topper', ["G Topper", "George Topper"])
  .set("Below Deck Alex 🚢", ["Alexander Hayton"])
  .set(`Pells - "Jimmy Saville, he's one of our own"`, ["PELLS H"])
  .set("Will 🟢", ["GREEN WM"]);
